import React from "react";
import factoryFloor from "../../assets/img/technology/factory-floor.jpg";
import Reveal from "../common/Reveal";
import NetworkBackground from "../common/NetworkBackground";

const Hero = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-primary-50 to-white">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <NetworkBackground className="absolute inset-0 h-full w-full" density={40} />
      </div>

      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 py-16 sm:px-6 lg:grid-cols-2 lg:px-8 lg:py-24">
        {/* 텍스트 영역 */}
        <Reveal>
          <span className="inline-block rounded-full bg-primary-100 px-4 py-1.5 text-sm font-semibold tracking-wide text-primary-700">
            TECHNOLOGY &amp; SERVICE
          </span>
          <h1 className="mt-6 break-keep text-4xl font-bold leading-tight text-primary-900 sm:text-5xl">
            제조업의 디지털 전환을 지원하는
            <br />
            MES 솔루션 및 스마트공장 구축
          </h1>
          <p className="mt-6 max-w-xl break-keep text-lg leading-relaxed text-gray-600">
            고객의 비즈니스 환경에 최적화된 플랫폼 서비스를 구축합니다.
            설비·센서 데이터를 실시간으로 수집·통합하고, AI 분석 엔진으로
            이상감지·품질예측·공정 최적화를 지원하는 MTST의 기술과
            서비스를 만나보세요.
          </p>
        </Reveal>

        {/* 이미지 영역 */}
        <Reveal direction="left" delay={100} className="relative">
          <div className="overflow-hidden rounded-xl shadow-2xl ring-1 ring-black/5">
            <img
              src={factoryFloor}
              alt="가동 중인 스마트 공장 생산 라인 전경"
              className="w-full"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Hero;
